import React from "react";
import "./style.scss";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { HomeCarouselImages } from "../../pagesContent/homeCarouselImages ";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export default function CarouselView() {
  return (
    <section>
      <div className="homeCarousel">
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={3000}
        >
          {HomeCarouselImages.map((val) => {
            return (
              <div className="image">
                <img alt="" src={val.path} />
              </div>
            );
          })}
        </Carousel>
      </div>
    </section>
  );
}
